import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import ReactPlayer from 'react-player';

import {
  Container,
  PlayerContent,
  HtmlContent,
  PageTitleContainer,
  PageIcon,
  Content,
  Title,
  Time,
  Actions,
  ActionsIcon,
  ActionsButton,
  DivisionDesktop,
} from './styles';
import '~/components/styles/Global.css';
import api from '~/services/api';
import back from '~/assets/images/arrow.svg';
import HeaderMobile from '~/components/layout/HeaderOld';
import Loading from '~/components/layout/Loading';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import { b64DecodeUnicode } from '~/utils/functions/b64DecodeUnicode';

export default function VideoPage({ props }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const playerRef = useRef(null);

  const trainingReducer = useSelector(state => state.trainingReducer);
  const watchVideos = useSelector(state => state.videoReducer);

  const [videosIndex, setVideosIndex] = useState(0);
  const [videoUrl, setVideoUrl] = useState('');
  const [loadingPage, setLoadingPage] = useState(true);
  const [videoControl, setVideoControl] = useState(false);
  const [youtubeVideo, setYoutubeVideo] = useState(false);
  const roles = useSelector(state => state.rolesReducer.roles);
  const [stateVideoItem, setStateVideoItem] = useState(null);
  const [playerHasBegan, setPlayerHasBegan] = useState(false);
  const [htmlTrain, setHtmlTrain] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState({
    publico: [],
    tag: [],
    video_cod: '',
    video_contador_visualizacoes: 0,
    video_data_publicacao: '',
    video_duracao: 0,
    video_id: '',
    video_inserted_at: '',
    video_thumbnail: '',
    video_titulo: '',
    video_url: '',
  });

  useEffect(() => {
    setPlayerHasBegan(false);
    dispatch({
      type: 'SET_WATCH_TIME',
      watchTime: 0,
      video: '',
      index: 0,
    });
    dispatch({ type: 'PLAY_PAUSE', play: false });
    var url = new URL(window.location.href);
    let index = parseInt(url.searchParams.get('index'));
    let isYoutube = false;
    if (!trainingReducer.videos[index].html){
      if (trainingReducer.videos[index].video_url.slice(12, 19) === 'youtube') {
        isYoutube = true;
      }
      setVideosIndex(index);
      setSelectedVideo(trainingReducer.videos[index]);
      dispatch({ type: 'SET_PAGE_VIDEO', page: 1 });
  
      let videoViewed = false;
      if (watchVideos.viewedVideos) {
        watchVideos.viewedVideos.map(video => {
          if (video === trainingReducer.videos[index].video_cod) {
            videoViewed = true;
          }
          return videoViewed;
        });
      }
      async function request() {
        if (!videoViewed) {
          await addViewRequest(index);
        }
        await getUserVideos(trainingReducer.videos[index], index, isYoutube);
      }
      request();
      setLoadingPage(false);
    } else {
      let html = trainingReducer.videos[index].fileBase64;
      setVideosIndex(index);
      setSelectedVideo(trainingReducer.videos[index]);
      setHtmlTrain(html);
      setLoadingPage(false);
      addViewRequestTrainCompliance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.search]);

  const addViewRequestTrainCompliance = async () => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      headers: header,
    };
    let url = `/residential/store/v1/users/${localStorage.getItem('userId')}`;
    await api
      .patch(
        url,
        {
          competitiveComplianceVisualized: true,
        },
        parameters,
      )
      .then(() => {
        localStorage.setItem('competitiveCompliance', true)
        dispatch({ type: 'SET_MODAL_HOME', openModalHome: false });
      });
  }

  const addViewRequest = async index => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      headers: header,
    };
    let url = `/residential/ultratop/v1/usuarios/${trainingReducer.userCode}/videos`;
    api
      .put(
        url,
        {
          videoCod: trainingReducer.videos[index].video_cod,
        },
        parameters,
      )
      .then(() => {
        let arraySeedVideos = watchVideos.viewedVideos;
        let hasCode = false;
        arraySeedVideos.map(element => {
          if (element === trainingReducer.videos[index].video_cod) {
            hasCode = true;
          }
        });
        if (!hasCode) {
          arraySeedVideos.push(trainingReducer.videos[index].video_cod);
          dispatch({
            type: 'SET_VIEWED_VIDEOS',
            viewedVideos: arraySeedVideos,
          });
        }
      });
  };

  const getUserVideos = async (videoSelected, index, isYoutube) => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      headers: header,
    };
    let url = `/residential/ultratop/v1/usuarios/${trainingReducer.userCode}/videos`;
    api
      .get(url, parameters)
      .then(async res => {
        let videoItem = null;
        for (let index = 0; index < res.data.data.length; index++) {
          if (videoSelected.video_cod === res.data.data[index].video_cod) {
            videoItem = res.data.data[index];
          }
        }
        if (isYoutube) {
          mountYoutubeVideo(videoSelected, await videoItem);
        } else {
          mountDefaultPlayer(videoSelected, await videoItem);
        }
        await addViewConters(videoSelected);
      })
      .catch(err => {
      });
  };

  const mountYoutubeVideo = (videoSelected, videoItem) => {
    setYoutubeVideo(true);
    if (videoItem === null) {
      setVideoUrl(`https://www.youtube.com/watch?v=${videoSelected.video_id}`);
    } else {
      if (videoItem.tempo_assistido >= videoSelected.video_duracao - 10) {
        setVideoUrl(
          `https://www.youtube.com/watch?v=${videoSelected.video_id}&t=0`,
        );
      } else {
        setVideoUrl(
          `https://www.youtube.com/watch?mode=opaque&rel=0&autohide=1&showinfo=0&wmode=transparent&v=${videoSelected.video_id}&t=${videoItem.tempo_assistido}`,
        );
      }
    }
  };

  const mountDefaultPlayer = (videoSelected, videoItem) => {
    setYoutubeVideo(false);
    setStateVideoItem(videoItem);
    let itemVideo = videoItem;
    if (itemVideo.tempo_assistido < videoSelected.video_duracao - 10) {
      setVideoUrl(videoSelected.video_url);
      playerRef.current.seekTo(itemVideo.tempo_assistido, 'seconds');
    } else {
      setVideoUrl(videoSelected.video_url);
      playerRef.current.seekTo(0);
    }
  };

  const addViewConters = async videoSelected => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      headers: header,
    };
    await api.put(
      '/residential/ultratop/v1/visualizacoes',
      {
        videoCod: videoSelected.video_cod,
        userCod: trainingReducer.userCode,
        publicoCod:
          videoSelected.publico.length < 1
            ? ''
            : videoSelected.publico[0].publico_cod,
      },
      parameters,
    );
  };

  const postViews = async counter => {
    if (watchVideos.play) {
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('access_token'),
      };
      const parameters = {
        headers: header,
      };
      await api.post(
        '/residential/ultratop/v1/visualizacoes',
        {
          videoCod: selectedVideo.video_cod,
          userCod: trainingReducer.userCode,
          tempoAssistido: counter,
        },
        parameters,
      );
    }
  };

  useEffect(() => {
    let videoTimer = null;
    if (watchVideos.play) {
      videoTimer = setInterval(() => playVideo(), 10000);
    } else {
      pauseVideo();
      if (videoTimer !== null) {
        clearInterval(videoTimer);
      }
    }
    return () => {
      clearInterval(videoTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchVideos.play]);

  function playVideo() {
    let counterTime =
      playerRef.current !== null
        ? Math.round(playerRef.current.getCurrentTime())
        : 0;
    counterTime =
      playerRef.current !== null
        ? Math.round(playerRef.current.getCurrentTime())
        : 0;
    postViews(counterTime);
  }

  function pauseVideo() {
    var url = new URL(window.location.href);
    let index = parseInt(url.searchParams.get('index'));
    let counterTime =
      playerRef.current !== null
        ? Math.round(playerRef.current.getCurrentTime())
        : 0;
    dispatch({
      type: 'SET_WATCH_TIME',
      watchTime: counterTime,
      video: selectedVideo.video_id,
      index: index,
    });
  }

  const progressVideoPlayer = () => {
    if (!playerHasBegan && watchVideos.play) {
      if (stateVideoItem.tempo_assistido < selectedVideo.video_duracao - 10) {
        playerRef.current.seekTo(stateVideoItem.tempo_assistido, 'seconds');
      } else {
        playerRef.current.seekTo(0);
      }
      setPlayerHasBegan(true);
    }
  };

  return (
    <Container>
      {verifyRoles(roles, 'TREINAMENTOS') ? (
        <>
          <div className="display-header">
            <HeaderMobile />
          </div>
          <PageTitleContainer>
            <PageIcon
              src={back}
              onClick={() => {
                let newPublics = trainingReducer.publicos;
                for (let index = 0; index < newPublics.length; index++) {
                  if (newPublics[index].selected) {
                    newPublics[index].selected = false;
                  }
                }
                dispatch({ type: 'SET_PUBLICOS', publicos: newPublics });
                history.push('/treinamentos');
              }}
            />
          </PageTitleContainer>
          {loadingPage ? (
            <Loading />
          ) : (
              <Content>
                {htmlTrain && (
                  <>
                    <HtmlContent>
                      <iframe style={{ width: '100%', height: '90vh' }} frameBorder="0" srcDoc={b64DecodeUnicode(htmlTrain)} />
                    </HtmlContent>
                  </>
                )}
                {!htmlTrain && (
                  <PlayerContent youtubeVideo={youtubeVideo}>
                    <ReactPlayer
                      ref={playerRef}
                      config={{
                        file: {
                          attributes: {
                            controlsList: 'nodownload',
                            playsinline: true,
                            onContextMenu: e => e.preventDefault(),
                          },
                        },
                      }}
                      onReady={() => setVideoControl(true)}
                      onProgress={() => progressVideoPlayer()}
                      controls={youtubeVideo ? true : videoControl}
                      style={{ margin: '0 auto' }}
                      width="100%"
                      height="100%"
                      url={videoUrl}
                      onPlay={() => dispatch({ type: 'PLAY_PAUSE', play: true })}
                      onPause={() => dispatch({ type: 'PLAY_PAUSE', play: false })}
                    />
                  </PlayerContent>
                )}
                {!htmlTrain && (
                  <DivisionDesktop>
                    <Title>{selectedVideo.video_titulo}</Title>
                    <Time>{Math.round(selectedVideo.video_duracao / 60)} min</Time>
                    <Actions
                      initial={videosIndex === 0}
                      final={videosIndex === trainingReducer.videos.length}
                    >
                      {videosIndex === 0 ? null : (
                        <ActionsButton
                          onClick={() =>
                            history.push(
                              `/treinamentos/video?index=${videosIndex - 1}`,
                            )
                          }
                        >
                          <ActionsIcon className="mdi mdi-skip-backward" />
                        Voltar
                        </ActionsButton>
                      )}
                      {trainingReducer.videos.length - 1 === videosIndex ? null : (
                        <ActionsButton
                          onClick={() =>
                            history.push(
                              `/treinamentos/video?index=${videosIndex + 1}`,
                            )
                          }
                        >
                          <ActionsIcon className="mdi mdi-skip-forward" />
                        Próximo
                        </ActionsButton>
                      )}
                    </Actions>
                  </DivisionDesktop>
                )}
              </Content>
            )}
        </>
      ) : (
          <Redirect to="/portal" />
        )}
    </Container>
  );
}
